export default "__VITE_ASSET__O1BZ31jE__"